var chunkMapping = {
	"webpack_container_remote_laboreModule_DropdownCursos": [
		"webpack/container/remote/laboreModule/DropdownCursos"
	],
	"webpack_container_remote_laboreModule_DropdownCursosRelacionados": [
		"webpack/container/remote/laboreModule/DropdownCursosRelacionados"
	],
	"webpack_container_remote_laboreModule_DropdownOcupacoes": [
		"webpack/container/remote/laboreModule/DropdownOcupacoes"
	],
	"webpack_container_remote_laboreModule_DropdownOcupacoesRelacionadas": [
		"webpack/container/remote/laboreModule/DropdownOcupacoesRelacionadas"
	],
	"webpack_container_remote_laboreModule_DropdownSeletorCursos": [
		"webpack/container/remote/laboreModule/DropdownSeletorCursos"
	],
	"webpack_container_remote_laboreModule_DropdownSetorAgrupado": [
		"webpack/container/remote/laboreModule/DropdownSetorAgrupado"
	],
	"webpack_container_remote_laboreModule_Landing": [
		"webpack/container/remote/laboreModule/Landing"
	],
	"webpack_container_remote_laboreModule_ThemeToggle": [
		"webpack/container/remote/laboreModule/ThemeToggle"
	],
	"webpack_container_remote_laboreModule_Chat": [
		"webpack/container/remote/laboreModule/Chat"
	],
	"webpack_container_remote_laboreModule_Assistants": [
		"webpack/container/remote/laboreModule/Assistants"
	],
	"webpack_container_remote_laboreModule_QuantidadeEscolas": [
		"webpack/container/remote/laboreModule/QuantidadeEscolas"
	],
	"webpack_container_remote_laboreModule_ListaEscolas": [
		"webpack/container/remote/laboreModule/ListaEscolas"
	],
	"webpack_container_remote_laboreModule_CursosSimilares": [
		"webpack/container/remote/laboreModule/CursosSimilares"
	],
	"webpack_container_remote_laboreModule_ItinerariosFormativos": [
		"webpack/container/remote/laboreModule/ItinerariosFormativos"
	],
	"webpack_container_remote_laboreModule_DistribuicaoGeografica": [
		"webpack/container/remote/laboreModule/DistribuicaoGeografica"
	]
};
var idToExternalAndNameMapping = {
	"webpack/container/remote/laboreModule/DropdownCursos": [
		"default",
		"./DropdownCursos",
		"webpack/container/reference/laboreModule"
	],
	"webpack/container/remote/laboreModule/DropdownCursosRelacionados": [
		"default",
		"./DropdownCursosRelacionados",
		"webpack/container/reference/laboreModule"
	],
	"webpack/container/remote/laboreModule/DropdownOcupacoes": [
		"default",
		"./DropdownOcupacoes",
		"webpack/container/reference/laboreModule"
	],
	"webpack/container/remote/laboreModule/DropdownOcupacoesRelacionadas": [
		"default",
		"./DropdownOcupacoesRelacionadas",
		"webpack/container/reference/laboreModule"
	],
	"webpack/container/remote/laboreModule/DropdownSeletorCursos": [
		"default",
		"./DropdownSeletorCursos",
		"webpack/container/reference/laboreModule"
	],
	"webpack/container/remote/laboreModule/DropdownSetorAgrupado": [
		"default",
		"./DropdownSetorAgrupado",
		"webpack/container/reference/laboreModule"
	],
	"webpack/container/remote/laboreModule/Landing": [
		"default",
		"./Landing",
		"webpack/container/reference/laboreModule"
	],
	"webpack/container/remote/laboreModule/ThemeToggle": [
		"default",
		"./ThemeToggle",
		"webpack/container/reference/laboreModule"
	],
	"webpack/container/remote/laboreModule/Chat": [
		"default",
		"./Chat",
		"webpack/container/reference/laboreModule"
	],
	"webpack/container/remote/laboreModule/Assistants": [
		"default",
		"./Assistants",
		"webpack/container/reference/laboreModule"
	],
	"webpack/container/remote/laboreModule/QuantidadeEscolas": [
		"default",
		"./QuantidadeEscolas",
		"webpack/container/reference/laboreModule"
	],
	"webpack/container/remote/laboreModule/ListaEscolas": [
		"default",
		"./ListaEscolas",
		"webpack/container/reference/laboreModule"
	],
	"webpack/container/remote/laboreModule/CursosSimilares": [
		"default",
		"./CursosSimilares",
		"webpack/container/reference/laboreModule"
	],
	"webpack/container/remote/laboreModule/ItinerariosFormativos": [
		"default",
		"./ItinerariosFormativos",
		"webpack/container/reference/laboreModule"
	],
	"webpack/container/remote/laboreModule/DistribuicaoGeografica": [
		"default",
		"./DistribuicaoGeografica",
		"webpack/container/reference/laboreModule"
	]
};
__webpack_require__.f.remotes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			var getScope = __webpack_require__.R;
			if(!getScope) getScope = [];
			var data = idToExternalAndNameMapping[id];
			if(getScope.indexOf(data) >= 0) return;
			getScope.push(data);
			if(data.p) return promises.push(data.p);
			var onError = (error) => {
				if(!error) error = new Error("Container missing");
				if(typeof error.message === "string")
					error.message += '\nwhile loading "' + data[1] + '" from ' + data[2];
				__webpack_require__.m[id] = () => {
					throw error;
				}
				data.p = 0;
			};
			var handleFunction = (fn, arg1, arg2, d, next, first) => {
				try {
					var promise = fn(arg1, arg2);
					if(promise && promise.then) {
						var p = promise.then((result) => (next(result, d)), onError);
						if(first) promises.push(data.p = p); else return p;
					} else {
						return next(promise, d, first);
					}
				} catch(error) {
					onError(error);
				}
			}
			var onExternal = (external, _, first) => (external ? handleFunction(__webpack_require__.I, data[0], 0, external, onInitialized, first) : onError());
			var onInitialized = (_, external, first) => (handleFunction(external.get, data[1], getScope, 0, onFactory, first));
			var onFactory = (factory) => {
				data.p = 1;
				__webpack_require__.m[id] = (module) => {
					module.exports = factory();
				}
			};
			handleFunction(__webpack_require__, data[2], 0, 0, onExternal, 1);
		});
	}
}